import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setExternalLink,
  setShowExternalPopup,
} from "../redux/slice/slicePopup";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";

const PopUpExternal = () => {
  const { getText } = useLanguageTranslation();
  const dispatch = useDispatch();
  const { showExternalPopup, externalLink } = useSelector(
    (state) => state.popupSlice
  );
  return (
    <Modal
      className="external-link-modal"
      show={showExternalPopup}
      onHide={() => {
        dispatch(setExternalLink(""));
        dispatch(setShowExternalPopup(false));
      }}
    >
      <Modal.Header>
        <Modal.Title>{getText("External Links", "बाहरी लिंक")}</Modal.Title>
        <Button
          type="button"
          className="close"
          onClick={() => {
            dispatch(setExternalLink(""));
            dispatch(setShowExternalPopup(false));
          }}
        >
          X
        </Button>
      </Modal.Header>
      <Modal.Body>
        {getText(
          "You are being redirected to an external website.",
          "आपको किसी बाहरी वेबसाइट पर पुनर्निर्देशित किया जा रहा है."
        )}
        <br />
        <strong style={{ wordBreak: "break-all" }}>{externalLink}</strong>
        <br></br>{" "}
        {getText("Click yes to continue", "जारी रखने के लिए हाँ पर क्लिक करें")}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          className="quick-btn clear-search-btn"
          onClick={() => {
            dispatch(setExternalLink(""));
            dispatch(setShowExternalPopup(false));
          }}
        >
          {getText("No", "नहीं")}
        </Button>
        <Button
          className="yes-button quick-btn"
          //   variant="primary"
          href={externalLink}
          target="_blank"
          onClick={() => {
            // dispatch(setExternalLink(""));
            dispatch(setShowExternalPopup(false));
          }}
        >
          {getText("Yes", "हाँ")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PopUpExternal;
